module.exports = __webpack_public_path__ + "static/img/重点工程_详情图@2x.93a012b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/重点工程_详情图@2x.png
// module id = ocp4
// module chunks = 1